// extracted by mini-css-extract-plugin
export var contentStyle = "Layout-module--contentStyle--8ce99";
export var footerStyle = "Layout-module--footerStyle--1e642";
export var fullscreenStyle = "Layout-module--fullscreenStyle--fb8a1";
export var mainStyle = "Layout-module--mainStyle--466f4";
export var portalStyle = "Layout-module--portalStyle--c149f";
export var wrapperStyle = "Layout-module--wrapperStyle--35915";